import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { getPromoCodeList, saveCity, promodata } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';
import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

class promoCodes extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        var auth_data = JSON.parse(localStorage.getItem("user_data"));
        this.state = {
              logged: localStorage.getItem("authentication"),
              auth_data: JSON.parse(localStorage.getItem("user_data")),
              location: location ? location : (auth_data.access_location ? auth_data.access_location : 'Bengaluru'),
              promolist: [],
              openedAdd:false,
              promo_id: 0,
              promo_code: '',
              promo_type: '1',
              promo_benefit: '',
              promo_usable: 0,
              partner_id: '',
               parnter_list: []
        };

        this.getPromoList();
        this.getPartner();
    }

  getPartner = () => {

    let ins = JSON.stringify({
      role: 1,
      url: 'getPartnerList'
    });
    promodata(ins).then((res) => {
      if (res.status == 1) {
        this.setState({
          parnter_list: res.plist,
        });
      } else {
        // window.location.href = '/promo_list';
      }

    });
  }

    componentDidMount() {

      var THIS = this;
      $(document).on('click', '.delete_promo', function () {
      var delete_id = $(this).data("id");
      THIS.setState({
        delete_id: delete_id
      });
      THIS.deletePackage(delete_id);
      });


    }

    deletePackage(delete_id = '') {
      if(confirm("Are you sure to Delete Promo Code?")==true){
           
            let ins = JSON.stringify({
              promo_id: delete_id ? delete_id : this.state.delete_id,
              role: 1,
              url: 'delete_promocode'
            });
            promodata(ins).then((res) => {
              if (res.status === 1) {
                NotificationManager.success(res.message);
                setTimeout(function () {
                  window.location.reload();
                }, 1000);
              } else {
                NotificationManager.error(res.message);
              }
            });
      }    
      return false;
    }

    openAddBox= () => {

      this.setState({openedAdd:true});
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
      
    };  


    savePromo = ()=>{
        
       let insert = JSON.stringify({
        promo_id: this.state.promo_id,
        promo_code: this.state.promo_code,
        partner_id: this.state.partner_id,
        promo_type: this.state.promo_type,
        promo_benefit: this.state.promo_benefit,
        promo_usable: this.state.promo_usable,
        url: 'update_promocode',
        role: 1
      })
      promodata(insert).then((response) => {
        if (response.status == 1) {
          this.setState({openedAdd:false});
          this.getPromoList();
        } else {
          alert("saving error");
        }
      });
     
    }

    getPromoList = () => {
      const { login_id, role } = this.state.auth_data;
      let ins = JSON.stringify({
        vendor_id: login_id,
        role: role
      });
      getPromoCodeList(ins).then((res) => {
        if (res.status == 1) {
          this.setState({
            promolist: res.list
            
          });
        } else {
          this.setState({
            promolist: [],
          });
        }
      });
    }    

    render() {

        const { promolist } = this.state;

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Promocodes</h4>
                 
 
                  <div class="float-right"><button class="btn btn-primary btn-sm" onClick={this.openAddBox}>Add New</button></div>
                 
                  {this.state.openedAdd &&
                    <form>
                     <div class="row col-lg-12">
                      
                      <div class="form-group">
                        
                        <div class="form-row">
                          
                          <label>Partner</label>
                          <select className='form-control selectpicker' data-live-search="true" name='partner_id'
                            value={this.state.partner_id}
                            title='Select'
                            onChange={this.handleChange}>
                            {
                              this.state.parnter_list.map((item, i) => {
                                return (
                                  <option value={item.login_id} key={i}>{item.pname + '/ ' + item.user_name}</option>
                                )
                              })
                            }

                          </select>

                        </div>
                      
                      <div class="form-row">
                        
                          <label> Promo Benefit <span className="astrick">*</span></label>
                         
                        
                          <input name='promo_benefit' className='form-control' type='text' value={this.state.promo_benefit}
                            onChange={this.handleChange} />
                          
                      </div>
                      <div class="form-row">
                        
                          <label> Type <span className="astrick">*</span></label>
                         
                          <select name='promo_type' className='form-control selectpicker'
                            value={this.state.promo_type} onChange={this.handleChange}>
                            <option value='1'>%</option>
                            <option value='2'>₹</option>
                          </select>
                          
                        
                      </div>

                       <div class="form-group row">
                          <div class="col-sm-10">
                            <button type="button" onClick={this.savePromo} class="btn btn-primary">Save</button>
                          </div>
                        </div>
                         
                      </div>

                     </div>

                     
                    </form>
                  }
                  
                  <div class="row col-lg-12">
                    
                      <div class="pt-3 table-responsive">
                    <table class="table table-bordered table-striped table-sm">
                      <thead class="thead-dark">
                        <tr>
                          <th >
                            <strong>S.No</strong>
                          </th>
                          <th >
                            <strong>Partner</strong>
                          </th>
                     
                          <th>
                            <strong>Benefit</strong>
                          </th>

                    

                          <th >
                            <strong>Action</strong>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                      {promolist.map((item, i) => {     
                      
                       return <tr>
                          <td  >
                            {i+1}
                          </td>
                                                  
                        
                          <td  >
                            {item.pname}
                          </td>
                         
                          <td  >
                            {item.benefit}
                          </td>
                         
                          
                          
                          <td  class="actionbtns" dangerouslySetInnerHTML={{__html: item.action}} />                             

                        </tr>

                      })

                      }
                       
                      </tbody>
                    </table>
                  </div>


                  </div>
                    
                </div>
              </div>
            </div>
            <NotificationContainer/>
                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default promoCodes;


// WEBPACK FOOTER //
// ./src/components/bewise/promoCodes.jsx